<template>
    <div class="error-message">
        <template v-if="!message">
            <h3>Nešto je pošlo po krivu.</h3>
            <ul>
                <li>A) Prošlo kolo nije odigrano</li>
                <li>B) Nema podataka za prikaz</li>
            </ul>
        </template>
        <h3 v-if="message">{{ message }}</h3>
    </div>
</template>

<script>

export default {
    name: 'errormessagetext',
    props: {
        message: String
    }
}
</script>

<style lang="scss" scoped>
.error-message {
    max-width: 350px;
    display: inline-block;
    h3, li {
        font-family: 'Axiforma';
    }
    h3 {
        color: $error-text-color;
        font-size: 18px;
    }
    ul, li {
        float: left;
        font-weight: 300;
    }
    ul {
        margin-bottom: 15px;
    }
    li {
        color: $font-black-color;
        line-height: 22px;
    }
}
</style>
